import React from 'react'
import './Service.css'
import { icons } from '../../utilits/icons'
import ReactApexChart from 'react-apexcharts'
import { serviceOrder } from '../../utilits/statisticTools'
import { orders } from '../../utilits/serviceOrder'
import { control } from '../../utilits/serviceControl'



export default function Service() {
  return (
    <div className='service'>
      <div className="service-container_top">
      <div className="service-container_left">
        <div className="service-station">
          <h1>Service Station</h1>
          <div className="service-stationsA">
            <div className='stationReady'>A1</div>
            <div className='stationReady'>A2</div>
            <div className='stationReady'>A3</div>
            <div className='stationBooking'>A4</div>
            <div className='stationReady'>A5</div>
            <div className='stationReady'>A6</div>
            <div className='stationReady'>A7</div>
            <div className='stationReady'>A8</div>
            <div className='stationReady'>A9</div>
            <div className='stationBooking'>A10</div>
          </div>
          <div className="service-stationsB">
            <div className='stationBooking'>B1</div>
            <div className='stationReady'>B2</div>
            <div className='stationReady'>B3</div>
            <div className='stationReady'>B4</div>
            <div className='stationReady'>B5</div>
            <div className='stationReady'>B6</div>
            <div className='stationBooking'>B7</div>
            <div className='stationReady'>B8</div>
            <div className='stationCurrent'>B9</div>
            <div className='stationReady'>B10</div>
          </div>

          <div className="serviceCondition">
            <div>
              <span>{icons.serviceReady}</span>
              <h2>Ready</h2>
            </div>
            <div>
              <span>{icons.serviceBooking}</span>
              <h2>Booked</h2>
            </div>
            <div>
              <span>{icons.serviceCurrent}</span>
              <h2>Current Station</h2>
            </div>
          </div>
        </div>

        <div className="serviceOrder">
          <div className="serviceOrder-container">
          <div className="serviceOrder-left">
              <h2>Your Order</h2>
              <div className="serviceOrder-time">
                <ReactApexChart options={serviceOrder.options} series={serviceOrder.series} type="donut" width={270} />
              </div>
              {/* <h3>Service <br /> Time <br /> <span>5,2h</span></h3> */}
          </div>
          <div className="serviceOrder-center">
            {
              orders.map((element, value)=>{
                return <div className='order-center'>
                  <div className="order-center_left">
                    <span>{element.icon}</span>
                    <h3>{element.name}</h3>
                  </div>
                  <p>$32</p>
                </div>
              })
            }
            <button className='order-add'>Add Services</button>
          </div>
          </div>
          <div className="serviceOrder-pay">
            <button>Pay $96</button>
          </div>
        </div>
      </div>

      <div className="service-container_right">
        <div className="service-required">
          <h1>Service Required</h1>
          <div className="required-steps">
            <div className="step-first">
              <div className="required-steps_icon">
                <span>{icons.serviceReqCare}</span>
              </div>
              <div className="required-steps_text">
                <h3>Center Care</h3>
                <div className="required-steps_text-bottom">
                  <h4>Price : $48</h4>
                  <p>Processing : 1 hours</p>
                </div>
              </div>
            </div>

            <div className="step-second">
              <div className="required-steps_icon">
                <span>{icons.serviceReqDiag}</span>
              </div>
              <div className="required-steps_text">
                <h3>Diagnostics</h3>
                <div className="required-steps_text-bottom">
                  <h4>Price : $78</h4>
                  <p>Processing : 2 hours</p>
                </div>
              </div>
            </div>

            <div className="step-third">
              <div className="required-steps_icon">
                <span>{icons.serviceReqClean}</span>
              </div>
              <div className="required-steps_text">
                <h3>Inner Cleaning</h3>
                <div className="required-steps_text-bottom">
                  <h4>Price : $78</h4>
                  <p>Processing : 1 hours</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-schedule">
          <h1>Service Schedule</h1>
          <div className="schedule-wrapper">
            <div className="schedule-wrapper_one">
              <form action="">
                <input type="radio" />
                <h4>Upgrade your favorite car <br /> periodically</h4>
              </form>
              <div className="schedule-text">
                <span>Today, 10.00</span>
                <span>Fix Price : $1,200</span>
              </div>
            </div>
            <div className="schedule-wrapper_two">
              <form action="">
                <input type="radio" />
                <h4>Buy spare parts for <br /> suspension</h4>
              </form>
              <div className="schedule-text">
                <span>Today, 14.00</span>
                <span>Fix Price : $1,400</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>


      <div className="service-container_bottom">
        {
          control.map((element, value) =>{
            return <div className='control-card'>
              <div className="control-card_img">
                <img src={element.image} alt="" />
              </div>
              <h3>{element.name}</h3>
              <div className="control-card_text">
                <p>{element.text1}</p>
                <p>{element.text2}</p>
              </div>
              <div className="control-card_icon">
                <span>{element.icon}</span>
              </div>
            </div>
          })
        }
      </div>
    </div>
  )
}
